import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AuthService} from './auth.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/do';
import swal from 'sweetalert2';
import {Router} from '@angular/router';
import {BaseService} from './base.service';
import {BroadcastService} from './broadcast.service';

@Injectable({providedIn: 'root'})
export class HttpErrorInterceptor implements HttpInterceptor {
    private refreshTokenInProgress = false;
    tokenRefreshedSource = new Subject();
    tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

    constructor(private auth: AuthService, private router: Router, private service: BaseService, public broadCastService: BroadcastService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(request).catch(error => {
            if (error.status === 401) {
                if (localStorage.getItem('refresh_token') != null) {
                    return this.refreshAccessToken()
                        .switchMap((data: any) => {
                            request = request.clone({headers: this.service.getHeaders()});
                            return next.handle(request);
                        })
                        .catch((error2) => {
                            this.logoutAlert();
                            return Observable.throwError(error2);
                        });
                } else {
                    return Observable.throwError(error);
                }
            } else {
                let ignoreError = false;
                if (
                    (request.url.includes('customerInvoice/createInvoiceFromOrder')) ||
                    (request.url.includes('retailerToDealerInvoice/createInvoiceFromOrder')) ||
                    (request.url.includes('tourAllowance/claim/approve')) ||
                    (request.url.includes('v4/marketTarget/upload')) ||
                    (request.url.includes('distributorDelivery/cancel')) ||
                    (request.url.includes('distributorProductDelivery/cancel')) ||
                    (request.url.includes('distributorDelivery/approve')) ||
                    (request.url.includes('distributorProductDelivery/approve')) ||
                    (request.url.includes('api/market-product-target-report/upload-target'))
                ) {
                    ignoreError = true;
                }
                if (error['error']['StatusMessage']) {
                    this.broadCastService.error.next(error['error']['StatusMessage']);
                    if (!ignoreError) {
                        swal('Error!', error['error']['StatusMessage'], 'error');
                    }
                } else {
                    let errors = '';
                    if (error['error']['errors']){
                        error['error']['errors'].forEach((pError, pIndex) => {
                            errors += pIndex + 1 + '. ' + pError + ' ';
                        });
                    } else {
                        errors = error['error']['error'];
                    }
                    if (!ignoreError) {
                        swal('Error!', errors, 'error');
                    }
                }

                return Observable.throwError(error);
            }
        });
    }

    refreshAccessToken(): Observable<any> {
        if (this.refreshTokenInProgress) {
            return new Observable(observer => {
                this.tokenRefreshed$.subscribe(() => {
                    observer.next();
                    observer.complete();
                });
            });
        } else {
            this.refreshTokenInProgress = true;
            return this.auth.refreshAccessToken()
                .do(() => {
                    this.refreshTokenInProgress = false;
                    this.tokenRefreshedSource.next();
                });
        }
    }

    logoutAlert(): void {
        swal({
            title: 'Error!',
            text: 'Your session has timed out. Please login again.',
            type: 'warning',
            backdrop: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            confirmButtonText: 'OK'
        }).then(
            value => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('user');
                this.router.navigate(['auth/login']);
            }
        ).catch(swal.noop);
    }
}
